const LocalStorageCleaner = () => {
    const elementosEliminar = ["maintenance", "consuption", "batery", "dataParams", "financial", "totals", "environment", "assurance", "productivity", "total_payed"];
  
    elementosEliminar.forEach((elemento) => {
      localStorage.removeItem(elemento);
    });
  }

export default LocalStorageCleaner